import { Link } from 'react-router-dom'

type LinkDecision = { internalTo?: string; externalTo?: string }

export type QuickLinksProps = {
  raw: string
  decideLink?: (href: string) => LinkDecision | undefined
}

type Item = { title: string; desc: string; href: string }

// Each line is "Title | description | /path". Blank lines are ignored.
function parse(raw: string): Item[] {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [title = '', desc = '', href = ''] = line.split('|').map((p) => p.trim())
      return { title, desc, href }
    })
    .filter((item) => item.title && item.href)
}

export default function QuickLinks({ raw, decideLink }: QuickLinksProps) {
  const items = parse(raw)
  return (
    <div className="quick-links">
      {items.map((item, i) => {
        const decision = decideLink ? decideLink(item.href) : undefined
        const internalTo = decision?.internalTo ?? (/^(https?:)?\/\//i.test(item.href) ? undefined : item.href)
        // Internal routes go through the router (no full reload); everything else is a plain link.
        if (internalTo) {
          return (
            <Link key={i} className="ql-card" to={internalTo}>
              <span className="ql-title">{item.title}</span>
              {item.desc && <span className="ql-desc">{item.desc}</span>}
            </Link>
          )
        }
        const href = decision?.externalTo ?? item.href
        return (
          <a key={i} className="ql-card" href={href} target="_blank" rel="noopener noreferrer">
            <span className="ql-title">{item.title}</span>
            {item.desc && <span className="ql-desc">{item.desc}</span>}
          </a>
        )
      })}
    </div>
  )
}
